import { CommonModule, ViewportScroller } from '@angular/common';
import { ChangeDetectorRef, Component, HostListener, Input, OnInit } from '@angular/core';
import { CommonSearchBarComponent } from '../../shared/common-search-bar/common-search-bar.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { CheckboxModule } from 'primeng/checkbox';
import { CommonServiceService } from '../../../utilities/services/common-service/common-service.service';
import { VideoCommonCardsComponent } from '../../shared/video-common-cards/video-common-cards.component';
import { PaginatorModule } from 'primeng/paginator';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { videoHeader } from '../../../../assets/constData/videoHeader';
import { SidebarModule } from 'primeng/sidebar';
import { AccordionModule } from 'primeng/accordion';
import { StatusOptions } from '../../../models/common/stream_status';
import { MultiSelectModule } from 'primeng/multiselect';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { EventFilterComponent } from '../../shared/event-filter/event-filter.component';
import { SkeletonLoaderComponent } from '../../shared/skeleton-loader/skeleton-loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { navigateToVideoStream } from '../../../utilities/utils/video-stream-navigation.util';

@Component({
  selector: 'stupa-all-videos',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    CommonSearchBarComponent,
    PaginatorModule,
    HttpClientModule,
    AccordionModule,
    MultiSelectModule,
    ToastModule,
    EventFilterComponent,
    SkeletonLoaderComponent,
    OverlayPanelModule,
    CheckboxModule,
    VideoCommonCardsComponent,
    SidebarModule,
    ScrollingModule,
  ],
  templateUrl: './all-videos.component.html',
  styleUrl: './all-videos.component.scss',
  providers: [MessageService],
})
export class AllVideosComponent implements OnInit {
  screenWidth: any;
  searchTimeout: any;
  searchQuery: string = '';
  video_list: any = [];
  tatal_videos: any;
  page_number: number = 1;
  first: number = 0; // First item index on the current page
  rows: number = 10; // Number of rows per page
  video_tab_list: any = videoHeader;
  sidebar_visible: boolean = false;
  events_list: any = [];
  first_category_id: any = null;
  categories_list: any = [];
  checked: boolean = false;
  stream_status: any = StatusOptions;
  selectedStatuses: any[] = [];
  selectedEventIds: { id: number }[] = [];
  selectedCategoryIds: { id: number }[] = [];
  status_list: any = [];
  is_loading: boolean = false;
  video_loading = false;
  isLive = false;
  object_type: any = 'match';
  selected_video_tab: any;
  // Infinite scroll state
  currentPage: number = 1;
  pageSize: number = 40;
  hasMoreData: boolean = true;
  isLoading: boolean = false; // for infinite scroll guard
  currentSearch: string = '';
  searchBarExpanded: boolean = false;
  /** Events, categories, and statuses committed by Apply (or a status deep link). */
  appliedVideoFilterCount = 0;
  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.screenWidth = document.documentElement.clientWidth;
  }

  @Input() is_sub_license: boolean = false;
  @Input() user_role_id: number = 0;
  constructor(
    private readonly commonservice: CommonServiceService,
    private readonly router: Router,
    private readonly messageService: MessageService,
    private readonly cdr: ChangeDetectorRef,
    private readonly route: ActivatedRoute,
    private readonly viewportScroller: ViewportScroller
  ) {
    this.screenWidth = document.documentElement.clientWidth;
    this.isLive = this.router.url === '/live';
  }
  ngOnInit() {
    if (!this.isLive) {
      this.get_events();
    }
    if (this.isLive) {
      this.object_type = null;
    }

    // Check for query parameters and pre-select status filter
    this.route.queryParams.subscribe(params => {
      if (params['status'] === 'TBS') {
        // Set selectedStatuses to the TBS value
        this.selectedStatuses = ['TBS'];
        // Find and mark the TBS option as selected for UI display
        const tbsOption = this.stream_status.find((option: any) => option.value === 'TBS');
        if (tbsOption) {
          tbsOption.selected = true;
        }
      }
      this.appliedVideoFilterCount = this.countSelectedVideoFilters();
      // Always call get_all_videos to load data (with or without filters)
      this.currentPage = 1;
      this.page_number = 1;
      this.hasMoreData = true;
      this.get_all_videos(this.currentPage);
    });
    this.selected_video_tab = this.video_tab_list[0];
  }

  onSearchChange(data: any) {
    // Clear any existing timeout
    clearTimeout(this.searchTimeout);

    // Update the search query
    this.searchQuery = data;
    this.currentSearch = data || '';

    // Handle empty input - call API without search parameter
    if (!data || data.trim() === '') {
      this.currentPage = 1;
      this.page_number = 1;
      this.hasMoreData = true;
      this.video_list = [];
      this.get_all_videos(this.currentPage, '');
      return;
    }

    // Only search if input has at least 3 characters
    if (data.trim().length >= 3) {
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.page_number = 1;
        this.hasMoreData = true;
        this.video_list = [];
        this.currentSearch = data.trim();
        this.get_all_videos(this.currentPage, this.currentSearch);
      }, 1000); // Reduced debounce time for better UX
    }
  }

  @HostListener('window:scroll', ['$event'])
  onScroll(event: Event) {


    if (this.isLoading || !this.hasMoreData) return;

    const windowHeight = globalThis.window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = globalThis.window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop + windowHeight >= documentHeight * 0.8) {

      this.loadMoreVideos();
    }
  }


  get_all_videos(page_number?: any, search: any = '', isLoadMore: boolean = false) {
    this.is_loading = true;
    // Do not set video_loading on load-more: it toggles *ngIf on the list and destroys DOM scroll position.
    this.video_loading = !isLoadMore;
    this.isLoading = true;
    this.commonservice
      .get_videos({
        object_type: this.object_type,
        event_id: null,
        object_id: null,
        status: null,
        search: search,
        limit: this.pageSize,
        page_num: page_number,
        event_ids: this.selectedEventIds.map((e) => e.id),
        category_ids: this.selectedCategoryIds.map((c) => c.id),
        video_status: this.isLive ? ['L'] : this.selectedStatuses,
        user_role_id: this.user_role_id,
      })
      .subscribe({
        next: (result: any) => {

          if (
            globalThis.window?.sessionStorage
          ) {
            sessionStorage.removeItem('view_video');
          }
          const resultData = result?.data || [];
          const [x, y] = isLoadMore ? this.viewportScroller.getScrollPosition() : [0, 0];
          this.video_list = isLoadMore ? [...this.video_list, ...resultData] : resultData;
          this.tatal_videos = this.video_list.length;
          this.hasMoreData = resultData.length > 0;
          this.is_loading = this.video_loading = this.isLoading = false;
          if (isLoadMore) setTimeout(() => this.viewportScroller.scrollToPosition([x, y]), 0);
        },
        error: (error: any) => {
          if (!isLoadMore) this.video_list = [];
          this.hasMoreData = false;
          this.is_loading = this.isLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: error.error.msg,
          });
        },
      });
  }

  loadMoreVideos() {
    if (this.isLoading || !this.hasMoreData) return;
    this.get_all_videos(++this.currentPage, this.currentSearch, true);
  }

  trackByVideoId(index: number, video: any): any {
    return video?.id || index;
  }

  onPageChange(event: any) {
    this.page_number = event.page + 1;
    this.first = event.first;
    this.rows = event.rows;

    // this.get_all_videos(this.page_number)
  }
  Video_data(data: any) {
    navigateToVideoStream(this.router, data, {
      live: this.isLive,
      requireAssetForScheduled: !this.isLive,
    });
  }

  open_filters() {
    this.sidebar_visible = true;
  }
  clear_filters = () => {
    this.selectedEventIds = [];
    this.selectedCategoryIds = [];
    this.selectedStatuses = [];
    // Reset all stream status options to unselected
    this.stream_status.forEach((option: any) => {
      option.selected = false;
    });
    this.events_list = [];
    this.appliedVideoFilterCount = 0;
    this.get_all_videos();
    this.get_events();
  };

  apply_filters = () => {
    this.appliedVideoFilterCount = this.countSelectedVideoFilters();
    this.get_all_videos();
    this.get_events();
    this.sidebar_visible = false;
  };

  private countSelectedVideoFilters(): number {
    return this.selectedEventIds.length
      + this.selectedCategoryIds.length
      + this.selectedStatuses.length;
  }

  get_events() {
    this.is_loading = true;
    this.commonservice.get_events('').subscribe({
      next: (result: any) => {
        this.is_loading = false;
        this.events_list = result.data.map((item: any) => {
          const existing = this.events_list.find((e: any) => e.id === item.id);

          const isSelected = this.selectedEventIds.some(
            (e) => e.id === item.id
          );

          return {
            ...item,
            selected: isSelected,
            categories: existing?.categories ?? [],
          };
        });

        this.cdr.detectChanges();
      },
      error: () => {
        this.is_loading = false;
      },
      complete: () => {
        this.is_loading = false;
      },
    });
  }

  get_events_categories(id: number, index: number) {
    this.commonservice.get_event_categories(id).subscribe({
      next: (result: any) => {
        const categories = result.data.map((cat: any) => {
          const isSelected = this.selectedCategoryIds.some(
            (c) => c.id === cat.category_id
          );
          return {
            ...cat,
            selected: isSelected,
          };
        });

        this.events_list[index].categories = categories;
      },
      error: () => undefined,
      complete: () => undefined,
    });
  }

  onEventSelection(event: any, index: number) {
    const existingIndex = this.selectedEventIds.findIndex(
      (e) => e.id === event.id
    );

    if (event.selected && existingIndex === -1) {
      this.selectedEventIds.push({ id: event.id });

      // Call category API
      this.commonservice
        .get_event_categories(event.id)
        .subscribe((res: any) => {
          const updatedEvent = {
            ...this.events_list[index],
            categories: (res.data || []).map((cat: any) => ({
              ...cat,
              selected: false,
            })),
          };

          // ✅ Replace array reference to trigger Angular change detection
          const clonedList = [...this.events_list];
          clonedList[index] = updatedEvent;
          this.events_list = clonedList;

          this.cdr.detectChanges(); // Optional
        });
    } else if (!event.selected && existingIndex !== -1) {
      this.selectedEventIds.splice(existingIndex, 1);

      const updatedEvent = {
        ...this.events_list[index],
        categories: [],
      };

      const clonedList = [...this.events_list];
      clonedList[index] = updatedEvent;
      this.events_list = clonedList;

      this.cdr.detectChanges(); // Optional
    }
  }

  onCategorySelection(cat: any) {
    const existingIndex = this.selectedCategoryIds.findIndex(
      (c) => c.id === cat.category_id
    );

    if (cat.selected && existingIndex === -1) {
      this.selectedCategoryIds.push({ id: cat.category_id });
    } else if (!cat.selected && existingIndex !== -1) {
      this.selectedCategoryIds.splice(existingIndex, 1);
    }
  }
  onCheckboxChange(option: any) {
    this.selectedStatuses = option.value;
  }

  remove_item(item: any) {
    // item is the string value (e.g., 'TBS', 'L', 'S')
    const index = this.selectedStatuses.findIndex(
      (val: any) => val === item
    );
    if (index !== -1) {
      this.selectedStatuses.splice(index, 1);
    }

    // Find the status option by value and mark as unselected
    const statusOption = this.stream_status.find(
      (opt: any) => opt.value === item
    );
    if (statusOption) {
      statusOption.selected = false;
    }
  }

  close_filters = () => {
    this.sidebar_visible = false;
  };
  set_video_type(video_tab: any) {
    this.selected_video_tab = video_tab;
    this.object_type = video_tab.value;
    this.currentPage = 1;
    this.page_number = 1;
    this.hasMoreData = true;
    this.video_list = [];
    this.get_all_videos(this.currentPage, this.currentSearch);
  }

  /**
   * Clear search and reset to initial state
   */
  clearSearch(): void {
    // Clear the search timeout
    clearTimeout(this.searchTimeout);

    // Reset search query
    this.searchQuery = '';
    this.currentSearch = '';

    // Reset to page 1 and fetch all videos without search
    this.currentPage = 1;
    this.page_number = 1;
    this.first = 0;
    this.hasMoreData = true;
    this.video_list = [];
    this.get_all_videos(this.currentPage, '');
  }
  onSearchBarInputExpanded(event: any) {
    this.searchBarExpanded = event;
    this.cdr.detectChanges();
  }
}
